export default __webpack_public_path__ + "static/media/testimonial-3.767e302a.png";